<mat-button-toggle-group
    [value]="activeView"
    aria-label="View selection"
    id="view-selection-btn-group"
>
    <mat-button-toggle [value]="PictureManagerViewModel.Pictures" (click)="changeView(PictureManagerViewModel.Pictures)">
        Pictures
    </mat-button-toggle>
</mat-button-toggle-group>
